import React, { ReactNode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { SimpleIntlProvider } from '../SimpleIntlProvider';

export interface IPortalProps {
  children: ReactNode;
  className?: string;
  el?: string;
}

export const Portal: React.FC<IPortalProps> = ({
  children,
  className = 'npaper-portal',
  el = 'div',
}) => {
  const [container] = useState(document.createElement(el));

  useEffect(() => {
    document.body.appendChild(container);
    container.classList.add(className);
    return () => {
      document.body.removeChild(container);
    };
  }, [className, container]);
  return ReactDOM.createPortal(
    <SimpleIntlProvider>{children}</SimpleIntlProvider>,
    container
  );
};
